import { render, staticRenderFns } from "./AutoUpdatesCardSkeleton.vue?vue&type=template&id=af393414&scoped=true"
import script from "./AutoUpdatesCardSkeleton.vue?vue&type=script&lang=js"
export * from "./AutoUpdatesCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AutoUpdatesCardSkeleton.vue?vue&type=style&index=0&id=af393414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af393414",
  null
  
)

export default component.exports